import { Laptop, Moon, SearchIcon, Sun } from "lucide-react";

import { Button } from "../../components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from "../../components/ui/dropdown-menu";
import { Separator } from "../../components/ui/separator";
import { SidebarTrigger } from "../../components/ui/sidebar";
import { type Theme, useTheme } from "../theme/theme-context";
import { NotificationBell } from "./notification-bell";
import { useQuickSearch } from "./quick-search-context";

/** Top bar: sidebar toggle, quick search (Ctrl+K) and the light/dark switch. */
export function AppHeader() {
  const { setOpen } = useQuickSearch();
  const { theme, resolved, setTheme } = useTheme();

  return (
    <header className="sticky top-0 z-40 flex h-16 shrink-0 items-center gap-3 border-b bg-background/80 px-4 backdrop-blur md:rounded-t-xl">
      <SidebarTrigger variant="secondary" aria-label="Show or hide the menu" />
      <Separator orientation="vertical" className="h-6" />
      <Button
        variant="secondary"
        onClick={() => setOpen(true)}
        aria-keyshortcuts="Control+K Meta+K"
        className="relative h-8 flex-1 justify-start bg-muted/25 font-normal text-muted-foreground shadow-none sm:w-56 sm:flex-none sm:pe-12 lg:w-72"
      >
        <SearchIcon aria-hidden="true" />
        <span>Quick search</span>
        <kbd className="pointer-events-none absolute end-1.5 top-1.5 hidden h-5 items-center gap-1 rounded border bg-muted px-1.5 font-mono text-[10px] font-medium select-none sm:flex">
          Ctrl K
        </kbd>
      </Button>
      <div className="ms-auto flex items-center gap-1">
        <NotificationBell />
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" size="icon" aria-label="Theme" className="rounded-full">
              {resolved === "dark" ? <Moon aria-hidden="true" /> : <Sun aria-hidden="true" />}
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuRadioGroup value={theme} onValueChange={(value) => setTheme(value as Theme)}>
              <DropdownMenuRadioItem value="light">
                <Sun aria-hidden="true" /> Light
              </DropdownMenuRadioItem>
              <DropdownMenuRadioItem value="dark">
                <Moon aria-hidden="true" /> Dark
              </DropdownMenuRadioItem>
              <DropdownMenuRadioItem value="system">
                <Laptop aria-hidden="true" /> Same as this computer
              </DropdownMenuRadioItem>
            </DropdownMenuRadioGroup>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
}
